import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { PaymentTermsAdapter } from './dto/payment-terms.adapter';
import { PaymentTermsController } from './payment-terms.controller';
import { PaymentTerms } from './payment-terms.entity';
import { PaymentTermsService } from './payment-terms.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([PaymentTerms]),
  ],
  controllers: [PaymentTermsController],
  providers: [PaymentTermsService,PaymentTermsAdapter,ApplicationExceptionHandler,LogsService]
})
export class PaymentTermsModule {}
